<template>
  <div class="form-group">
    <label>{{ label }}</label>
    <div></div>
    <span v-for="choice in choices">
      <label class="radio-inline">
        {{ choice.label }}
      </label>
      <input 
       type="radio" 
       :value="choice.value"
       :name="name"
       :checked="choice.checked"
       v-on:change="$emit('change', choice.value)"
       >
    </span>    
  </div>
</template>


<script>
export default {
  props: ['choices', 'name', 'label']
};
</script>